module.exports = __webpack_public_path__ + "img/67_30.587c4b38.png";